import { put, takeLatest, all, call } from "redux-saga/effects";
import { generateInvoiceApi, getInvoiceListApi, updatePaymentStatusApi, uploadInvoiceJsonApi } from "../api/invoicing";
import { invoices } from "../../constants/actionTypes";
import { toasterFlags } from "../../constants/componentConstants";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import {
  errorGenerateInvoice,
  setInvoiceListError,
  setInvoiceListSuccess,
  successGenerateInvoice,
  updateInvoicePaymentStatusError,
  updateInvoicePaymentStatusSuccess,
  uploadInvoiceJsonError,
  uploadInvoiceJsonSuccess,
} from "../actions";

export function* generateInvoice({ payload }) {
  try {
    const data = yield call(generateInvoiceApi, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, "Invoice generated successfully");
      yield put(successGenerateInvoice(data));
    } else {
      yield put(errorGenerateInvoice(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorGenerateInvoice(err));
  }
}
export function* getInvoiceList({ payload }) {
  try {
    const data = yield call(getInvoiceListApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setInvoiceListSuccess(data?.data));
    } else {
      yield put(setInvoiceListError(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(setInvoiceListError(err));
  }
}

export function* uploadInvoiceJsonTemplate({ payload }) {
  try {
    const data = yield call(uploadInvoiceJsonApi, payload);
    if (data?.status === statusCode.Created201) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.message);
      yield put(uploadInvoiceJsonSuccess(data));
    } else {
      yield put(uploadInvoiceJsonError(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(uploadInvoiceJsonError(err));
  }
}
export function* updatePaymentStatus({ payload }) {
  try {
    const data = yield call(updatePaymentStatusApi, payload?.invoiceId, payload?.data);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.message);
      yield put(updateInvoicePaymentStatusSuccess(data));
    } else {
      yield put(updateInvoicePaymentStatusError(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(updateInvoicePaymentStatusError(err));
  }
}

export function* invoiceWatcherSaga() {
  yield takeLatest(invoices.GENERATE_INVOICE, generateInvoice);
  yield takeLatest(invoices.GET_INVOICES_LIST, getInvoiceList);
  yield takeLatest(invoices.UPLOAD_INVOICE_JSON, uploadInvoiceJsonTemplate);
  yield takeLatest(invoices.UPDATE_INVOICE_PAYMENT_STATUS, updatePaymentStatus);
}

export default function* invoicingSaga() {
  yield all([invoiceWatcherSaga()]);
}
